import React from 'react';
import { Mui, MuiStyles } from '@osu/react-ui';
import AuthButton from '../components/AuthButton';
import JobsIndicator from '../components/JobsIndicator';
import { AUTH_ROLES, NAVBAR_WRAPPER_ID } from '../../util/constants';
import { Link } from 'react-router-dom';
import ApplicantDetailsPageAppBar from '../../Applicant/components/appBar';
import useRoleAuthentication from "../../Authentication/hooks/useRoleAuthentication";

const createClasses = (theme) => {
    return {
        appBar: {
          top: '0',
          zIndex: theme.zIndex.appBar,
          "& a:not(:last-child)": {
            marginRight: "1rem",
          }
        },
        root: {
          flexGrow: 1
        },
        menuButton: {
          marginRight: theme.spacing(2),
        },
        title: {
          flexGrow: 1,
        },
      }
};

const LINKS = [
    { path: "/"                             , label: "Application Review"       , roles: ["READ-ACCESS", "STUDENT-EMPLOYEE", AUTH_ROLES.HONORS_PROGRAM_COORDINATOR, AUTH_ROLES.HONORS_SEASONAL_MANAGER] },
    { path: "/manage-applications"          , label: "Manage"                   , roles: ["HONORS-ADMIN", "PROGRAM-ADMIN", AUTH_ROLES.HONORS_SEASONAL_MANAGER] },
    { path: "/reports"                      , label: "Reports"                  , roles: ["HONORS-ADMIN", "PROGRAM-ADMIN", AUTH_ROLES.HONORS_SEASONAL_MANAGER] },
 // { path: "/exports"                      , label: "Exports"                  , roles: ["HONORS-ADMIN", "PROGRAM-ADMIN"] },
    { path: "/reviewers/active"             , label: "Reviewers"                , roles: ["HONORS-ADMIN"] },
    { path: "/configurations"               , label: "Configurations"           , roles: ["HONORS-ADMIN"] },
    { path: "/search"                       , label: "Search"                   , roles: ["HONORS-ADMIN", AUTH_ROLES.HONORS_PROGRAM_COORDINATOR, AUTH_ROLES.HONORS_SEASONAL_MANAGER] }, // Adding this to STUDENT-EMPLOYEE would be redundant & look weird as '/' auto-redirects here
 // { path: "/manage-cycles"                , label: "Cycles"                   , roles: ["????CYCLESADMIN?"] },
];

export default function Navbar() {
  const { isHonorsAdmin, isScholarsAdmin } = useRoleAuthentication()
  const classes = createClasses(MuiStyles.useTheme());

  return (
    <Mui.AppBar id={NAVBAR_WRAPPER_ID} color="inherit" sx={classes.appBar} position="sticky">
        <Mui.Toolbar>
            { LINKS.map(NavigationLink) }
            
            <Mui.Typography sx={{ flexGrow: 1 }} /> {/* Fill the horizontal space */}
            
            {(isHonorsAdmin || isScholarsAdmin) && <JobsIndicator />}
            <AuthButton />
        </Mui.Toolbar>

        <ApplicantDetailsPageAppBar />
    </Mui.AppBar>
  );
}

function NavigationLink({ path, label, roles }, index) {
    const { user } = useRoleAuthentication();
    
    if (!roles.some(role => user?.applicationRoles?.includes(role))) { return <React.Fragment key={index} />; }
    
    const navbutton = { ":focus-visible": { "outline": "2pt solid #0060df", "border-radius": "2px" } };
    
    return <Mui.Button component={Link} key={path} to={path} sx={navbutton}>{label}</Mui.Button>
}